//import ConfirmStuResetSupplyPopup from "@/pages/comp/supply/supply/popup/confirm_stu_reset_supply";
import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import getXcolumnJson from "./xcolumn/list";
import ListArea from "./area/list";

function ConfirmStuResetSupplyPopup(props: any) {
  let myProps = {
    stu_seq_arr: [],
    list_opt: {},
    confirm_btn_text: "확인",
    confirm_msg: "해당 청구서를 초기화 하고, 계속 하시겠습니까?",
    on_confirm: () => { },
    refresh_data: (inData: any) => { },
    closePopup: () => { },
    ...props
  };

  const xColumnArr = getXcolumnJson();
  let now_start_date = DateFunc.get_date_format(new Date(), "Y-m-01");
  let next_month_end_date = DateFunc.get_date_format(DateFunc.get_change_date(new Date(now_start_date),'month',+1), "Y-m-t");
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_date_type: 'a_date',
    s_start_date: now_start_date,
    s_end_date: next_month_end_date,
    s_state: "unpay",
    s_stu_seq: "",
    s_addon_user: "1",
    is_paging: "",
    ...myProps.list_opt
  });
  const [infoArr, setInfoArr] = useState([]);
  
  useEffect(() => {
    let able_stu_seq_arr: any = [];
    for (let i = 0; i < myProps.stu_seq_arr.length; i++) {
      if (!strFunc.is_empty(myProps.stu_seq_arr[i])) {
        able_stu_seq_arr.push(myProps.stu_seq_arr[i]);
      }
    }
    if (!strFunc.is_empty(able_stu_seq_arr)) {
      list({
        s_stu_seq: able_stu_seq_arr
      });
    }
  }, []);

  const list = (inOptObj: any) => {
    let change_listOpt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(change_listOpt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/list', change_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const go_confirm = () => {
    if (confirm(myProps.confirm_msg) === false) {
      myProps.closePopup();
      return;
    }
    myProps.on_confirm();
    myProps.closePopup();
  };

  return (
    <div>
      <div>
        <h3>해당 학생의 청구서 초기화 됩니다. 계속 하시겠습니까?</h3>
        <div>
          {now_start_date.substring(5,7)}월 , {next_month_end_date.substring(5,7)}월 기간의 미납 청구서만 초기화 됩니다.
        </div>
        <div>
          {infoArr.length}건
        </div>
      </div>
      <div>
        <ListArea
          xColumnArr={xColumnArr}
          info_arr={infoArr}
        ></ListArea>
      </div>
      <div className='my_flex_center mt-1'>
        <button className="btn btn-dark"
          onClick={() => {
            go_confirm();
          }}
        >{myProps.confirm_btn_text}</button>
        <button className="btn btn-dark"
          onClick={() => {
            myProps.closePopup();
          }}
        >닫기</button>
      </div>
    </div>
  );
};
export default ConfirmStuResetSupplyPopup;